import { Text, Flex, Image } from '@chakra-ui/react';
import { pbIcons } from 'theme/icons/Icon';

export const FeedStatus = ({ name }) => {
    return (
        <Flex alignItems="center">
            <Image src={pbIcons.statusBigRedException} boxSize={4} mb={0.5} />

            <Text fontSize="sm" fontWeight="bold" casing="uppercase" ml={1}>
                {name}
            </Text>
        </Flex>
    );
};
